import { render, staticRenderFns } from "./FundingReciveIcon.vue?vue&type=template&id=032fd1ca&"
import script from "./FundingReciveIcon.vue?vue&type=script&lang=js&"
export * from "./FundingReciveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports